<template>
  <v-row class="app-drawer">
    <v-navigation-drawer
      v-if="isVisible"
      fixed
      hide-overlay
      :transition="transition"
      :permanent="permanent"
      :right="!isRTL && !isBottom"
      :bottom="isBottom"
      :tag="tag"
      :width="width"
      :value="true"
      v-bind="resetProps"
      dense
      shapped
      :left="isRTL && !isBottom"
    >
      <template #prepend>
        <slot name="header" />
      </template>
      <template #default>
        <slot name="body" />
        <slot />
      </template>
      <template #append>
        <slot name="footer" />
      </template>
    </v-navigation-drawer>
    <div class="app-drawer-overlay" v-if="isVisible" @click.stop="handleOnCloseAppDrawer"></div>
  </v-row>
</template>

<script>
import "./styles.scss";
import { $eventHub } from "@/components";
import { EventConstraints } from "@/enums/events.enum";

export default {
  name: "AppDrawer",
  props: {
    isVisible: {
      required: true,
      type: Boolean,
      default: false,
    },

    handleOnClose: {
      type: Function,
      default: () => {},
    },

    tag: {
      default: "aside",
    },

    width: {
      default: "auto",
    },

    permanent: {
      default: false,
      type: Boolean,
    },

    transition: {
      default: "",
      type: String,
    },

    fullscreen: {
      default: false,
      type: Boolean,
    },

    isBottom: {
      default: false,
      type: Boolean,
    },
  },

  mounted() {
    $eventHub.$on(EventConstraints.TOGGLE_APP_DRAWER, this.handleOnCloseDrawer);
  },

  watch: {
    isVisible: {
      immediate: true,
      deep: true,
      handler(value) {
        document.documentElement.style.overflow = "auto";
        if (value) {
          document.documentElement.style.overflow = "hidden";
        }
      },
    },
  },

  destroyed() {
    this.$destroy();
    this.$delete;
    $eventHub.$off(EventConstraints.TOGGLE_APP_DRAWER, this.handleOnCloseDrawer);
  },

  computed: {
    isRight() {
      return !this.$vuetify.rtl;
    },

    resetProps() {
      return { ...this.$attrs };
    },

    isRTL() {
      return this.$vuetify.rtl;
    },
  },

  methods: {
    handleOnCloseAppDrawer() {
      if (this.permanent) {
        return;
      }

      this.handleOnCloseDrawer();
    },

    /**
     * handle to close app drawer
     * @return {void}
     */
    handleOnCloseDrawer() {
      this.handleOnClose();
    },
  },
};

/**
 * @name App Drawer
 * @example <AppDrawer
 *             :isVisible="isDrawerVisible"
 *             :handleOnClose="toggoleDrawer">
 *               <template #header>...</template>
 *               <template #body>...</template>
 *               <template #footer>...</template>
 *          </AppDrawer>
 * @requires {isVisible: Boolean, handleOnClose: Function}
 */
</script>

<style src="./styles.scss" scoped lang="scss" />
